import {Component, OnInit} from '@angular/core';
import {CalcRequestModel} from '../../models/calc-request.model';
import {StorageHelperService} from '../../services/storage-helper.service';
import {Router} from '@angular/router';
import { TokenManager } from '../../services/TokenManager';
import { UserResponseModel } from '../../models/user-response.model';


@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.less']
})
export class TariffChoose implements OnInit {

  calcRequestModel: CalcRequestModel = new CalcRequestModel();
  travelModal = false;
  smartmodal = false;
  kidsModal = false;
  premiumModal = false;
  horizontModal = false;
  rizikoModal = false;
  EliteModal = false;
  investModal = false;
  mesovitoModal = false;
  familyModal = false;
  safeModal = false;
  kolektivModal = false;
  type: string;

  user: UserResponseModel = new UserResponseModel();

  constructor(private router: Router,  private tokenManager: TokenManager) {

    this.user = this.tokenManager.retrieveCurrentUser();
  }

  ngOnInit() {
    sessionStorage.clear();
    window.scroll(0, 0);
  }


  submitCalc() {
// this.calcRequestModel.StatNr = 11110;
// this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalc'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcComfort() {
    // this.calcRequestModel.StatNr = 50112;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcComfortComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcSave() {
     this.calcRequestModel.Tarifa = 20;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcElite'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


  submitCalcG1() {
    this.calcRequestModel.Tarifa = 1;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalc'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcG3() {
    this.calcRequestModel.Tarifa = 3;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalc'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcG5() {
    this.calcRequestModel.Tarifa = 5;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalc'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


  submitCalcSmart11() {
    this.calcRequestModel.Tarifa = 31;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcJednokratno'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcPro() {
    this.calcRequestModel.Tarifa = 32;

    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcJednokratno'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcSuperSmart11() {
    this.calcRequestModel.Tarifa = 310;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcJednokratno'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcKids11() {
    this.calcRequestModel.Tarifa = 36;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcJednokratno'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcInvest() {
    this.calcRequestModel.Tarifa = 12;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcJednokratno'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


  submitCalcElite() {
    this.calcRequestModel.Tarifa = 20;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcElite'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcPremium() {
    this.calcRequestModel.Tarifa = 20;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcPremium'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcSmart() {
    this.calcRequestModel.Tarifa = 30;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcSmart'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcKids() {
    this.calcRequestModel.Tarifa = 35;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcKids'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


  submitCalcR1() {
    this.calcRequestModel.Tarifa = 10;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcR1'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcRK5() {
    this.calcRequestModel.Tarifa = 50;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcRK5'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcHorizont() {
    this.calcRequestModel.Tarifa = 15;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcHorizont'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcK() {
    this.calcRequestModel.Tarifa = 16;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcK'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcRK11() {
    this.calcRequestModel.Tarifa = 11;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcRK11'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


  submitCalccapital() {
    // this.calcRequestModel.StatNr = 11010;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcCapitalComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcStart() {
    // this.calcRequestModel.StatNr = 41110;
    // this.calcRequestModel.Branche = 94;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcStartComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


  submitCalcSafelife() {
    this.calcRequestModel.Tarifa = 300;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalc'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


  submitCalcFamilyPartner() {
    this.calcRequestModel.Tarifa = 400;
    // this.calcRequestModel.Branche = 91;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TariffCalcFamilyPartner'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcProfit() {
    //this.calcRequestModel.Tarifa = 11;
    //this.calcRequestModel.Branche = 97;

    //Grawe Invest
    localStorage.setItem('type', 'ГРАВЕ ИНВЕСТ');

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcFondComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcProfitDinamics() {
    //this.calcRequestModel.Tarifa = 11;
    //this.calcRequestModel.Branche = 97;

    //VFP dinamics
    localStorage.setItem('type', 'ВФП Граве Динамик');

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcFondComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

 
  submitCalcSafeLifeGlobal() {
    //this.calcRequestModel.Tarifa = 11;
    //this.calcRequestModel.Branche = 97;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcSafeLifeGlobalComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcProfitJunior() {
    //this.calcRequestModel.Tarifa = 11;
    //this.calcRequestModel.Branche = 97;

    localStorage.setItem('type', 'ГРАВЕ ИНВЕСТ Јуниор');

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcFondJuniorComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcProfitJuniorDinamics() {
    //this.calcRequestModel.Tarifa = 11;
    //this.calcRequestModel.Branche = 97;

    localStorage.setItem('type', 'ВФП Граве Динамик Јуниор');

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcFondJuniorComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }






  submitCalcProfitJuniorPlus() {
    //this.calcRequestModel.Tarifa = 11;
    //this.calcRequestModel.Branche = 97;

    // StorageHelperService.PullData('CalcRequestModel');
    StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
    this.router.navigate(['TarrifCalcFondJuniorplusComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }

  submitCalcKolektiv() {
    this.calcRequestModel.Tarifa = 99;
   // this.calcRequestModel.Branche = 91;

   // StorageHelperService.PullData('CalcRequestModel');
   StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
   this.router.navigate(['TariffCalcKolektiv'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

 }


}



// WEBPACK FOOTER //
// ./src/app/pages/TariffChoose/TariffChoose.ts